import { loanLodeStarQuestionsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_LODESTAR_QUESTIONS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/lodeStarQuestions`,
  {
    GET_LODESTAR_QUESTIONS: 'GET_LODESTAR_QUESTIONS',
    EDIT_LODESTAR_QUESTIONS: 'EDIT_LODESTAR_QUESTIONS',
    RESET_LODESTAR_QUESTIONS: 'RESET_LODESTAR_QUESTIONS',
  },
);

export const getLoanLodeStarQuestionsAction = catchAsyncActionError(
  ({ loanId }) =>
    async dispatch => {
      const { data } = await loanLodeStarQuestionsApi.getLodeStarQuestions({ loanId });

      return dispatch({
        type: LOAN_LODESTAR_QUESTIONS_ACTION_TYPE.GET_LODESTAR_QUESTIONS,
        payload: data,
      });
    },
);

export const editLoanLodeStarQuestionsAction = catchAsyncActionError(
  ({ loanId, answers, recalculateFees }) =>
    async dispatch => {
      await loanLodeStarQuestionsApi.editLodeStarQuestions({
        loanId,
        answers,
        recalculateFees,
      });

      return dispatch({
        type: LOAN_LODESTAR_QUESTIONS_ACTION_TYPE.EDIT_LODESTAR_QUESTIONS,
        payload: { answers },
      });
    },
);

export const resetLoanLodeStarQuestionsAction = () => ({
  type: LOAN_LODESTAR_QUESTIONS_ACTION_TYPE.RESET_LODESTAR_QUESTIONS,
});
